/* eslint-disable max-len */
/**
 * Galeria de fotos de clientes
 */
export const EAZZY_CLIENTS: { name: string; image: string }[] = [
  {
    name: 'Belisario',
    image: 'https://ugc.production.linktr.ee/addfca38-3dfd-4697-9858-d8bd9f54c4c4_120092838-649634369016052-8408959641664865155-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Mamasita Medallo',
    image: 'https://ugc.production.linktr.ee/06cc21d2-051e-4476-8f01-3994d75c5bb6_36ef75bb-298b-48f7-9ecb-09b744a6eaa1-image.png?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'La Rufina',
    image: 'https://ugc.production.linktr.ee/5f44bf2d-4d92-4e07-80af-d8c75190b474_348312773-216099837861252-1343654116547934800-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Guzman y mezcal',
    image: 'https://ugc.production.linktr.ee/0fbce6f8-f4b0-4668-a916-6d4c6f91f8e2_340339505-613505590312350-6392418667666618950-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'El callejon del gato',
    image: 'https://ugc.production.linktr.ee/19322426-e99c-49ea-84ea-a8cb1d014baa_473138388-17896055586134192-3331013389166559624-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Carolina',
    image: 'https://ugc.production.linktr.ee/30905907-54ae-4b58-9cd7-f87ee4a426e6_470944810-2302178356818033-3749219767383998433-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Ene',
    image: 'https://ugc.production.linktr.ee/65709923-a38c-4e94-aa3e-3e243625f854_284930658-390480033138939-2102316832753850181-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Nezia',
    image: 'https://ugc.production.linktr.ee/a1b24f80-89ae-4168-92c6-5c2568283af1_279880103-550672353322525-1367867378539273343-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Volá',
    image: 'https://ugc.production.linktr.ee/36c7632c-27f6-40df-9c96-a4ff05fe6f2e_472321055-18013792886657458-2060888386422594047-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'La Oculta',
    image: 'https://ugc.production.linktr.ee/55276a68-67dc-44bf-a40f-567801214674_474007768-18342258523197936-1609449628547334565-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Calante',
    image: 'https://ugc.production.linktr.ee/f4a560ea-41f7-4687-8db1-40c2e8c0ee5e_445680172-1155120609249448-7958326902666059499-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: '100 fuegos',
    image: 'https://ugc.production.linktr.ee/88b8bfe7-c4d4-49e2-a5f7-5733ba9ecd26_276108246-116784834281995-8238449630816517805-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Super 8',
    image: 'https://ugc.production.linktr.ee/4138b5e5-e4b9-4a4f-b735-c601cd37784f_210865809-562240801605278-2842747968087896261-n.jpeg?io=true&size=thumbnail-product-v1_0',
  },
  {
    name: 'Wan',
    image: 'src="https://ugc.production.linktr.ee/e9453a54-d6fa-453e-8dab-1309aeaf4559_395901847-301201842842960-7784677067418204066-n.jpeg?io=true&size=thumbnail-product-v1_0"',
  }
];
